import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Checkbox } from 'design-system/src/components/Checkbox/Checkbox';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { ErrorMessage } from 'design-system/src/components/ErrorMessage/ErrorMessage';
import Button from 'design-system/src/components/Button/Button';
import { attestationContent, attestationCheckboxLabel, attestationErrorMessage } from './sharedCopy';

import { Modal, ModalTitle, ModalBody, ModalFooter, ModalFooterAlignment } from 'design-system/src/components/Modal';

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  // Compensate for checkbox padding
  margin: -12px 0 -10px -12px;
`;

interface PriorAuthSubmitModalProps {
  onClose: () => void;
  onSubmit: (checked: boolean) => void;
  isSubmitting: boolean;
}

export const PriorAuthSubmitModal = ({ onClose, onSubmit, isSubmitting }: PriorAuthSubmitModalProps) => {
  const [checked, setChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (checked && showError) {
      setShowError(false);
    }
  }, [checked, showError]);

  const handleSubmit = () => {
    if (!checked) {
      setShowError(true);
    } else {
      onSubmit(checked);
    }
  };

  return (
    <Modal onClose={onClose}>
      <ModalTitle>Attestation</ModalTitle>

      <ModalBody>
        <Typography>{attestationContent}</Typography>

        <div>
          <CheckboxContainer>
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
              aria-labelledby="prior-auth-submit-modal-checkbox-label"
            />
            <Typography id="prior-auth-submit-modal-checkbox-label">{attestationCheckboxLabel}</Typography>
          </CheckboxContainer>
          <ErrorMessage visible={showError} marginTop={'0.5rem'}>
            {attestationErrorMessage}
          </ErrorMessage>
        </div>
      </ModalBody>

      <ModalFooter align={ModalFooterAlignment.Left}>
        <Button onClick={handleSubmit} isLoading={isSubmitting}>
          Accept and submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};
